import Modal from 'react-modal';

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(0,0,0, 0.5)',
        zIndex: 1000,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'none',
        inset: 'none',
        borderRadius: 'none',
        border: 0,
        background: 'none',
    },
};

const InfoDialog = ({ isOpen, content, onClose }) => {
    return (
        <Modal
            style={customStyles}
            isOpen={isOpen}>
            <div className="dialogbox show"  >
                <div className="modal-dialog" >
                    <div className="modal-content card-border">
                        <div className="modal-icon">
                            <ion-icon name="checkmark-circle"></ion-icon>
                        </div>
                        <div className="modal-body mt-2">
                            {content}
                        </div>
                        <div className="modal-footer">
                            <div className="btn-inline">
                                <a className="btn" onClick={onClose}>Close</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </Modal>
    )
}

export default InfoDialog;
